// Access token lives in module memory only — never localStorage, never a cookie
// the JS layer can read. Refresh token is httpOnly on the server side.

import type { Role, Scope } from "@/types/api";

export interface AuthState {
  accessToken: string | null;
  scope: Scope | null;
  role: Role | null;
  tenantId: string | null;
}

type Listener = (state: AuthState) => void;

let state: AuthState = { accessToken: null, scope: null, role: null, tenantId: null };
const listeners = new Set<Listener>();

export function getAuth(): AuthState {
  return state;
}

export function setAuth(next: AuthState): void {
  state = next;
  listeners.forEach((l) => l(state));
}

export function clearAuth(): void {
  setAuth({ accessToken: null, scope: null, role: null, tenantId: null });
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
